import { createApiSlice } from "@common";
import {
  CRUD_ACCOUNT_BILLING_DETAIL,
  GET_ACCOUNT_BILLING_DETAIL_BY_ACCOUNT_ID,
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addAccountBillingDetail",
    method: "post",
    url: CRUD_ACCOUNT_BILLING_DETAIL,
    stateKey: "message",
  },
  {
    name: "getAccountBillingDetailByAccountId",
    method: "get",
    url: GET_ACCOUNT_BILLING_DETAIL_BY_ACCOUNT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "accountBillingDetail",
  apiConfig,
  customReducers
);

const accountBillingDetailSlice = slice;

export default accountBillingDetailSlice.reducer;

export const {
  addAccountBillingDetail,
  getAccountBillingDetailByAccountId,
} = thunks;
